<template>
  <div class="container">
    <img
      :src="item.imgPath ? `${apiUrl}/image?name=${item.imgPath}` : defaultImg"
      alt=""
      class="bg"
    />
    <div class="return" @click="back">返回</div>
    <div class="title">
      <img class="left" src="@/assets/images/bg-temple-left.png" />
      <div class="center">{{ item.name }}</div>
      <img src="@/assets/images/bg-temple-right.png" class="right" />
    </div>
    <div v-if="item.type === 2" class="price">
      {{ item.name || '贴金' }} {{ $money.fenToYuan(item.amount) }}元/{{
        item.unit
      }}
    </div>
    <van-form ref="form" show-error-message class="form" @submit="onSubmit">
      <van-field
        v-if="item.type === 2"
        v-model="form.num"
        label-width="120"
        name="num"
        placeholder="请输入"
        :required="false"
        :rules="[
          {
            validator: validateCount,
            message: '请输入大于0,小于等于10000的正整数'
          },
          {
            required: true,
            message: `请输入${item.name || '贴金'}数量`
          }
        ]"
        type="digit"
        @input="onChangeCount"
      >
        <template #label>
          <div class="label">
            <span class="required">*</span>
            <span class="content">{{ item.name || '贴金' }}</span>
            <span style="width: 10px; text-align: right">:</span>
          </div>
        </template>

        <template #extra>
          <div class="extra">{{ item.unit || '张' }}</div>
        </template>
      </van-field>
      <van-field
        v-model="form.amount"
        label-width="120"
        name="amount"
        :placeholder="item.type === 2 ? '' : '请输入'"
        :required="false"
        :rules="[
          { required: true, message: '请输入金额' },
          {
            validator: validateMoney,
            message: '请输入正确的金额（大于0，最多两位小数）'
          }
        ]"
        :readonly="item.type === 2"
        @input="onChangeMoney"
      >
        <template #label>
          <div class="label">
            <span class="required">*</span>
            <span class="content">总金额</span>
            <span style="width: 10px; text-align: right">:</span>
          </div>
        </template>
        <template #extra>
          <div class="extra">元</div>
        </template>
      </van-field>
      <van-field
        v-model="form.userName"
        label-width="120"
        name="userName"
        placeholder="请输入"
        :required="false"
      >
        <template #label>
          <div class="label">
            <span class="content">芳名</span>
            <span style="width: 10px; text-align: right">:</span>
          </div>
        </template>
      </van-field>
      <van-field
        v-model="form.phone"
        label-width="120"
        name="phone"
        placeholder="请输入"
        :required="false"
      >
        <template #label>
          <div class="label">
            <span class="content">联系方式</span>
            <span style="width: 10px; text-align: right">:</span>
          </div>
        </template>
      </van-field>

      <div class="btn" @click="onSubmit">{{ item.buttonName || '随喜' }}</div>
    </van-form>
  </div>
</template>

<script>
import defaultImg from '@/assets/images/bg-temple-default.png';
import { payProject } from '@/api/donate/index.js';
export default {
  name: '',
  components: {},
  data() {
    return {
      defaultImg,
      item: {},
      form: {
        num: '',
        amount: '',
        userName: '',
        phone: ''
      },
      apiUrl: process.env.VUE_APP_BASE_API
    };
  },
  computed: {
    // count字段的校验规则
    countRules() {
      return [
        { required: true, message: `请输入${this.item.name || '贴金'}数量` },
        {
          validator: (val) => this.validateCountMax(val),
          message: '请输入大于0,小于等于10000的正整数'
        }
      ];
    }
  },
  async created() {
    this.item = JSON.parse(this.$route.query.item);
  },
  mounted() {},
  methods: {
    onSubmit() {
      this.$refs.form.validate().then(async () => {
        try {
          const res = await payProject(
            this.item.type === 2
              ? {
                  amount: this.$money.yuanToFen(this.form.amount),
                  num: this.form.num,
                  userName: this.form.userName,
                  phone: this.form.phone,
                  organizationId: this.$route.query.organizationId,
                  donationId: this.item.id
                }
              : {
                  amount: this.$money.yuanToFen(this.form.amount),
                  num: 1,
                  userName: this.form.userName,
                  phone: this.form.phone,
                  organizationId: this.$route.query.organizationId,
                  donationId: this.item.id
                }
          );
          if (res.code === 0) {
            window.location.href = res.data.qrCode;
          }
        } catch (err) {
          console.log(err);
        }
      });
    },

    // 验证count（大于0的正整数）
    validateCount(value) {
      const strValue = String(value).trim();

      // 检查是否为正整数（不包含小数点、负号等）
      const positiveIntegerRegex = /^[1-9]\d*$/;
      if (!positiveIntegerRegex.test(strValue)) {
        return false;
      }

      // 转换为数字再检查一次
      const numValue = Number(strValue);
      if (
        isNaN(numValue) ||
        numValue <= 0 ||
        !Number.isInteger(numValue) ||
        numValue > 10000
      ) {
        return false;
      }

      return true; // 验证通过
    },

    // 输入时实时限制金额格式（只允许数字和最多两位小数）
    onChangeMoney(value) {
      if (this.item.type === 1) {
        // type为1时，金额是自动计算的，不需要处理手动输入
        return;
      }

      // 如果为空，不做处理
      if (!value) {
        this.form.amount = value;
        return;
      }

      let strValue = String(value);

      // 移除所有非数字和小数点的字符
      strValue = strValue.replace(/[^\d.]/g, '');

      // 如果以小数点开头，前面补0
      if (strValue.startsWith('.')) {
        strValue = '0' + strValue;
      }

      // 只保留第一个小数点
      const dotIndex = strValue.indexOf('.');
      if (dotIndex !== -1) {
        const beforeDot = strValue.substring(0, dotIndex);
        const afterDot = strValue.substring(dotIndex + 1).replace(/\./g, '');
        // 限制小数点后最多两位
        strValue = beforeDot + '.' + afterDot.substring(0, 2);
      }

      // 更新值
      this.$nextTick(() => {
        this.form.amount = strValue;
      });
    },

    // 验证money（大于0的最多两位小数金额）
    validateMoney(value) {
      const strValue = String(value).trim();
      // 不允许以0开头（除非是0.xx的形式）
      if (
        strValue.length > 1 &&
        strValue.startsWith('0') &&
        strValue[1] !== '.'
      ) {
        return false;
      }
      // 检查是否为有效的金额格式（最多两位小数）
      const moneyRegex = /^\d+(\.\d{1,2})?$/;
      if (!moneyRegex.test(strValue)) {
        return false;
      }

      // 转换为数字检查
      const numValue = Number(strValue);
      if (isNaN(numValue) || numValue <= 0) {
        return false;
      }

      return true; // 验证通过
    },

    onChangeCount(value) {
      if (this.item.type === 2) {
        // 只有当count是有效数字时才计算金额
        const countValue = value || '';
        const strValue = String(countValue).trim();
        const positiveIntegerRegex = /^[1-9]\d*$/;

        if (positiveIntegerRegex.test(strValue)) {
          this.form.amount = this.$money.fenToYuan(
            this.$money.mul(countValue, this.item.amount)
          );
        } else {
          this.form.amount = '';
        }
      }
    },

    back() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss">
html,
body {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .van-field__control::-webkit-input-placeholder {
  color: #91613b99;
  font-size: 14px;
  font-weight: 400;
  font-family: 'PingFang SC';
}
.container {
  background-color: #fbf4e2;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;
  .bg {
    width: 100%;
    height: 211px;
  }
  .return {
    width: 96px;
    height: 34px;
    border-radius: 0 57px 57px 0;
    opacity: 1;
    background: #ab3a2a;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    font-family: 'PingFang SC';
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 15px;
  }
  .title {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    height: 56px;
    background-image: url('~@/assets/images/bg-temple-center.png');
    background-position: center;
    background-size: 148px 73px;
    background-repeat: no-repeat;

    .left,
    .right {
      width: 333px;
      height: 15px;
      position: absolute;
    }
    .left {
      right: 0;
      top: 0;
    }
    .right {
      left: 0;
      bottom: 0;
    }
    .center {
      height: 24px;
      min-width: 148px;
      opacity: 1;
      color: #ab3a2a;
      font-size: 24px;
      font-weight: 500;
      font-family: 'PingFang SC';
      text-align: center;
      line-height: 24px;
      letter-spacing: 6px;
    }
  }
  .price {
    color: #91613b;
    font-size: 14px;
    font-weight: 500;
    margin-top: 20px;
    width: 100%;
    text-align: left;
    padding-left: 16px;
    box-sizing: border-box;
  }
  .form {
    width: 100%;
    margin-top: 20px;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 48px;
    background-color: #fbf4e2;

    .label {
      color: #91613b;
      font-size: 16px;
      font-weight: 500;
      font-family: 'PingFang SC';
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: flex;
      align-items: center;
      margin-right: 10px;
      .required {
        color: #f00703;
        flex-shrink: 0;
      }
      .content {
        margin: 0 5px;
        margin-left: 3px;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: justify;
        text-align-last: justify;
        text-justify: inter-ideograph;
      }
    }
    .extra {
      color: #91613b;
      font-size: 16px;
      font-weight: 500;
    }
    ::v-deep .van-field {
      width: 343px;
      border-radius: 6px;
      opacity: 1;
      border: 0.5px solid #91613b;
      margin-bottom: 15px;
      background-color: transparent;
      padding: 16px;
      .van-field__control {
        color: #91613b;
        font-size: 16px;
        font-weight: 400;
        font-family: 'PingFang SC';
        text-align: left;
        line-height: 16px;
      }
      .van-field__label {
        margin-right: 0;
      }
    }
    .btn {
      width: 343px;
      height: 48px;
      background-image: url('~@/assets/images/bg-temple-btn.png');
      background-size: 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      font-family: 'PingFang SC';
      text-align: left;
      line-height: 16px;
      letter-spacing: 15px;
      text-indent: 15px;

      cursor: pointer;
    }
  }
}
</style>
